export const skeletonTimezone = 'AST (–1/+1 h)'
